import { render, staticRenderFns } from "./checklist-checkboxes-list.vue?vue&type=template&id=066a990a&scoped=true"
import script from "./checklist-checkboxes-list.vue?vue&type=script&lang=js"
export * from "./checklist-checkboxes-list.vue?vue&type=script&lang=js"
import style0 from "./checklist-checkboxes-list.vue?vue&type=style&index=0&id=066a990a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "066a990a",
  null
  
)

export default component.exports